import { render, staticRenderFns } from "./ViewRegions.vue?vue&type=template&id=555b4847&scoped=true"
import script from "./ViewRegions.vue?vue&type=script&lang=js"
export * from "./ViewRegions.vue?vue&type=script&lang=js"
import style0 from "./ViewRegions.vue?vue&type=style&index=0&id=555b4847&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555b4847",
  null
  
)

export default component.exports